export namespace AccountCreateEnum {
  export enum CERTIFICATION_TYPE {
    MOBILE = 'MOBILE',
    I_PIN = 'I_PIN'
  }

  export enum CHECK_DUPLICATE_TYPE {
    IDENTIFIER = 'IDENTIFIER',
    APPLE_IDENTIFIER = 'APPLE_IDENTIFIER',
    PHONE = 'PHONE',
    EMAIL = 'EMAIL'
  }

  export enum IDENTIFIER_TYPE {
    NOT_EDIT = 'NOT_EDIT',
    NOT_CHECKED = 'NOT_CHECKED',
    INVALID = 'INVALID',
    DUPLICATED = 'DUPLICATED',
    CONFIRM = 'CONFIRM'
  }

  export enum PASSWORD_TYPE {
    NOT_EDIT = 'NOT_EDIT',
    INVALID = 'INVALID',
    CONTINUE = 'CONTINUE',
    PRIVACY_IN = 'PRIVACY_IN',
    CONFIRM = 'CONFIRM',
  }

  export enum PASSWORD_CONFIRM_TYPE {
    NOT_EQUAL = 'NOT_EQUAL',
    EQUAL = 'EQUAL'
  }

  export enum EMAIL_TYPE {
    NOT_EDIT = 'NOT_EDIT',
    INVALID = 'INVALID',
    DUPLICATED = 'DUPLICATED',
    CONFIRM = 'CONFIRM'
  }

  export enum PHONE_TYPE {
    NOT_EDIT = 'NOT_EDIT',
    LIMIT_ACCOUNT = 'LIMIT_ACCOUNT',
    INVALID = 'INVALID',
    VALID = 'VALID'
  }

  export enum PHONE_AUTH_SEND_TYPE {
    SEND = 'SEND',
  }

  export enum AUTH_TYPE {
    TIMEOUT = 'TIMEOUT',
    NOT_EQUAL = 'NOT_EQUAL',
    CONFIRM = 'CONFIRM'
  }

  export enum QUALITY_CODE {
    REGULAR = 'REGULAR',
    NORMAL = 'NORMAL'
  }

  export enum STATUS_CODE {
    ACTIVE = 'ACTIVE',
    WAIT = 'WAIT',
    QUIT = 'QUIT',
    LEAVE = 'LEAVE',
    DORMANT = 'DORMANT'
  }

  export enum SNS_CODE {
    FACEBOOK = 'FACEBOOK',
    NAME_FACEBOOK = '페이스북',

    TWITTER = 'TWITTER',
    NAME_TWITTER = '트위터',

    CTN_HOME_BOY = 'CTN_HOME_BOY',
    NAME_CTN_HOME_BOY = '홈보이',

    KAKAOTALK = 'KAKAOTALK',
    NAME_KAKAOTALK = '카카오톡',

    GENIE_HOME = 'GENIE_HOME',
    NAME_GENIE_HOME = '지니 홈',

    MEDIA_PACK = 'MEDIA_PACK',
    NAME_MEDIA_PACK = '미디어팩',

    GIGA_GENIE = 'GIGA_GENIE',
    NAME_GIGA_GENIE = '기가지니',

    NAVER = 'NAVER',
    NAME_NAVER = '네이버',

    APPLE = 'APPLE',
    NAME_APPLE = '애플',

    NORMAL = 'NORMAL',
    CTN_KT = 'CTN_KT',
    CTN_LG = 'CTN_LG',
  }


  export enum AIR_BRIDGE_CATEGORY {
    join_1 = 'join_1',
    join_2 = 'join_2',
    airbridge_user_signup = 'airbridge.user.signup',
  }

  export enum KIND_CODE {
    ALL_JOIN_MARKETING = 'ALL_JOIN_MARKETING',
  }
}